var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Endpoints } from '@brg/api';
import React, { memo } from 'react';
import { ImageWrapper, Image, RibbonText } from './styles';
import { useResizedImageEnhanced } from '../../hooks/useResizedImageEnhanced';
var ResizedImageEnhanced = function (_a) {
    var className = _a.className, files = _a.files, onClick = _a.onClick, fixedSize = _a.fixedSize, placeholder = _a.placeholder, showDefaultPlaceholder = _a.showDefaultPlaceholder, showEmptyPlaceholder = _a.showEmptyPlaceholder, isRibbon = _a.isRibbon, position = _a.position, text = _a.text, onLoad = _a.onLoad, rest = __rest(_a, ["className", "files", "onClick", "fixedSize", "placeholder", "showDefaultPlaceholder", "showEmptyPlaceholder", "isRibbon", "position", "text", "onLoad"]);
    var _b = useResizedImageEnhanced(files, fixedSize), image = _b[0], containerRef = _b[1];
    return (React.createElement(ImageWrapper, { isDefaultPlaceholder: showEmptyPlaceholder || showDefaultPlaceholder, ref: containerRef, className: className, onClick: onClick, isRibbon: isRibbon, position: position },
        image && (React.createElement(Image, __assign({ alt: ' ', src: "".concat(Endpoints.files, "/").concat(image === null || image === void 0 ? void 0 : image.url) }, rest, { onLoad: onLoad, crossOrigin: "anonymous" }))),
        isRibbon && text && position !== 'caption-bottom' && React.createElement(RibbonText, { position: position }, text),
        !image && !showDefaultPlaceholder && (React.createElement(Image, __assign({ src: placeholder }, rest)))));
};
export default memo(ResizedImageEnhanced);
//# sourceMappingURL=ResizedImageEnhanced.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Endpoints } from '@brg/api';
import React, { memo } from 'react';
import { ImageWrapper, Image, RibbonText } from './styles';
import { useResizedImageEnhanced } from '../../hooks/useResizedImageEnhanced';
var ResizedImageEnhanced = function (_a) {
    var className = _a.className, files = _a.files, onClick = _a.onClick, fixedSize = _a.fixedSize, placeholder = _a.placeholder, showDefaultPlaceholder = _a.showDefaultPlaceholder, showEmptyPlaceholder = _a.showEmptyPlaceholder, isRibbon = _a.isRibbon, position = _a.position, text = _a.text, onLoad = _a.onLoad, rest = __rest(_a, ["className", "files", "onClick", "fixedSize", "placeholder", "showDefaultPlaceholder", "showEmptyPlaceholder", "isRibbon", "position", "text", "onLoad"]);
    var _b = useResizedImageEnhanced(files, fixedSize), image = _b[0], containerRef = _b[1];
    return (React.createElement(ImageWrapper, { isDefaultPlaceholder: showEmptyPlaceholder || showDefaultPlaceholder, ref: containerRef, className: className, onClick: onClick, isRibbon: isRibbon, position: position },
        image && (React.createElement(Image, __assign({ alt: ' ', src: "".concat(Endpoints.files, "/").concat(image === null || image === void 0 ? void 0 : image.url) }, rest, { onLoad: onLoad, crossOrigin: "anonymous" }))),
        isRibbon && text && position !== 'caption-bottom' && React.createElement(RibbonText, { position: position }, text),
        !image && !showDefaultPlaceholder && (React.createElement(Image, __assign({ src: placeholder }, rest)))));
};
export default memo(ResizedImageEnhanced);
//# sourceMappingURL=ResizedImageEnhanced.js.map